module.exports = __webpack_public_path__ + "img/INT-mob.014f1ca5.jpg";